import updateCollectionDateService from "./updateCollectionDateService";

const collectionDateService = [
    ...updateCollectionDateService
];

export { collectionDateService as default, updateCollectionDateService }